<template>
  <div>
    <div class="col-sm-6">
      <div class="camera-preview" ref="cameraPreview"></div>
    </div>
    <div class="col-sm-6">
      <CallSettingsDevicesSelect
        label="Camera"
        :sources="videoSources"
        :disabled="!isControlsAvailable"
        default-name-prefix="Video source"
        v-model="selectedVideoSource"
        icon="icon-video-solid"
      ></CallSettingsDevicesSelect>
      <CallSettingsDevicesSelect
        label="Microphone"
        :sources="audioSources"
        :disabled="!isControlsAvailable"
        default-name-prefix="Audio source"
        v-model="selectedAudioSource"
        icon="icon-microphone-solid"
      ></CallSettingsDevicesSelect>

      <div class="progress" style="height: 10px; margin-bottom: 0; margin-top: -5px;">
        <div
          class="progress-bar"
          role="progressbar"
          :aria-valuenow="previewAudioLevel"
          aria-valuemin="0"
          aria-valuemax="1"
          :style="{ width: `${previewAudioLevel * 100}%` }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DEVICE_TYPE, OPENTOK_AUDIO_UPDATED_EVENT } from "../enums";
import OT from "@opentok/client";
import { getNormalizedAudioLevel } from "../helpers";
import CallSettingsDevicesSelect from "./CallSettingsDevicesSelect";
export default {
  name: "CallSettingsDevices",
  components: { CallSettingsDevicesSelect },
  data() {
    return {
      isControlsAvailable: false,
      previewPublisher: null,
      previewAudioLevel: 0
    };
  },
  mounted() {
    this.isControlsAvailable = false;
    this._createPreviewPublisher();
  },
  destroyed() {
    if (this.previewPublisher) {
      this.previewPublisher.off(OPENTOK_AUDIO_UPDATED_EVENT);
      this.previewPublisher.publishVideo(false);
    }
  },
  computed: {
    ...mapGetters("calls/devices", ["videoSources", "audioSources"]),
    /** Handle video device update */
    selectedVideoSource: {
      get() {
        return this.$store.state.calls.devices.selectedVideoSource;
      },
      set(deviceId) {
        this.$emit("deviceUpdated", { type: DEVICE_TYPE.VIDEO, deviceId });
        this._updatePreviewSource(DEVICE_TYPE.VIDEO, deviceId);
      }
    },
    /** Handle audio device update */
    selectedAudioSource: {
      get() {
        return this.$store.state.calls.devices.selectedAudioSource;
      },
      set(deviceId) {
        this.$emit("deviceUpdated", { type: DEVICE_TYPE.AUDIO, deviceId });
        this._updatePreviewSource(DEVICE_TYPE.AUDIO, deviceId);
      }
    }
  },
  methods: {
    _createPreviewPublisher() {
      this.previewPublisher = OT.initPublisher(
        this.$refs.cameraPreview,
        {
          audioSource: this.selectedAudioSource,
          videoSource: this.selectedVideoSource,
          showControls: false,
          mirror: false
        },
        err => {
          if (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            return;
          }
          this.isControlsAvailable = true;
          this.previewPublisher.on(OPENTOK_AUDIO_UPDATED_EVENT, event => {
            this.previewAudioLevel = getNormalizedAudioLevel(event.audioLevel);
          });
        }
      );
    },
    /**
     * Update video or audio source for preview
     * @param {String} deviceType
     * @param {String} deviceId
     * @private
     */
    _updatePreviewSource(deviceType, deviceId) {
      this.$store.dispatch("calls/devices/updatePublisherSource", {
        publisher: this.previewPublisher,
        deviceType: deviceType,
        source: deviceId
      });
    }
  }
};
</script>

<style>
.camera-preview {
  width: 220px;
  height: 135px;
  background-color: black;
}
</style>
